import script from "./dynamic-table2.vue?vue&type=script&setup=true&lang=js"
export * from "./dynamic-table2.vue?vue&type=script&setup=true&lang=js"

import "./dynamic-table2.vue?vue&type=style&index=0&id=6dbc3484&lang=css"

const __exports__ = script;

export default __exports__